import { genericService } from "./genericService";

const section = "TypeCharge";

function filter(name = " ", from = "0", limit = "10", active = "1") {
  return genericService.filter(section, "types", name, from, limit, active);
}
function getAll() {
  return genericService.get("TypeCharge/ListAllTypeCharge");
}

function remove(id) {
  return genericService.remove(section, id);
}

function create(item) {
  const param = {
    typeCharge: item.typeCharge,
  };
  return genericService.create(section, param);
}

function update(item) {
  const param = {
    id: item.id,
    typeCharge: item.typeCharge,
    isActive: item.isActive,
  };
  return genericService.update(section, param);
}

export const typeChargeService = {
  getAll,
  filter,
  remove,
  create,
  update,
};
